import React from 'react';
/**
 * Config for Overview Display.
 * @return {OverviewLogic}
 */
function OverviewLogic() {
  return (<h1>Overview</h1>

  );
}

export default OverviewLogic;
